import { cn } from '@/lib/utils';

interface BreachCraftLogoProps {
  className?: string;
  /** Use white version for dark backgrounds (default), black for light backgrounds */
  variant?: 'white' | 'black';
  /** Alt text for accessibility */
  alt?: string;
}

/**
 * Breach Craft logo component
 * Uses the official PNG logos from brand assets
 */
export function BreachCraftLogo({
  className,
  variant = 'white',
  alt = 'Breach Craft',
}: BreachCraftLogoProps) {
  const src = variant === 'white' ? '/logo-white.png' : '/logo-black.png';

  return (
    <img
      src={src}
      alt={alt}
      className={cn('w-10 h-10 object-contain', className)}
    />
  );
}

/**
 * Breach Craft logo with text
 * For use in headers and larger displays
 */
export function BreachCraftLogoFull({
  className,
  variant = 'white',
}: Omit<BreachCraftLogoProps, 'alt'>) {
  const src = variant === 'white' ? '/logo-white.png' : '/logo-black.png';

  return (
    <img
      src={src}
      alt="Breach Craft"
      className={cn('h-12 w-auto object-contain', className)}
    />
  );
}
